import type { TOC } from '@ember/component/template-only';
import pageTitle from 'ember-page-title/helpers/page-title';
import TermsOfUse from 'parog-web/components/legal-info/terms-of-use';

const MyTemplate: TOC<{ Args: { model: unknown; controller: unknown } }> =
  <template>
    {{pageTitle 'Informations légales'}}

    <TermsOfUse />
  </template>;

export default MyTemplate;
